import { Injectable } from '@angular/core';
import { ConfigService } from './config.service';
import { RequestService } from './request.service';
import { Observable } from 'rxjs';

@Injectable()
export class CatalogProductsService {
  joinEvent(event: any): Observable<any> {
    let url = this.configService.get('server').url + this.configService.get('endpoints').solar.catalog.events.join.api + '/' + event.id;
    return this.requestService.post(url, {});
  }

  getCourseEvents(courseId: string): Observable<any> {
    let url = this.configService.get('server').url + this.configService.get('endpoints').solar.catalog.events.list.api + '/' + courseId + '?status=new';
    return this.requestService.get(url);
  }

  constructor(private configService: ConfigService, private requestService: RequestService, ) { }

  getCatalogProductSkus(paginator?: any): Observable<any> {
    let url = this.configService.get('server').url + this.configService.get('endpoints').voucherSystem.catalog.productSkus.api;
    if (paginator) url += '?page=' + paginator.page + '&limit=' + paginator.limit + '&filter=' + paginator.filter;
    return this.requestService.get(url);
  }
  getCatalogProducts(data: any) {
    let url = this.configService.get('server').url + this.configService.get('endpoints').solar.catalog.products.api;
    return this.requestService.get(url, data);
  }
  getCatalogProductAssignment(data: any) {
    let url = this.configService.get('server').url + this.configService.get('endpoints').solar.catalog.productAssignment.api + '/' + data;
    return this.requestService.get(url);
  }

}



// WEBPACK FOOTER //
// ./src/app/core/services/catalog-products.service.ts